"use client";

import { cn, priceFormatter } from "@/lib/utils";
import { Icons } from "./icons";
import { BlurFade } from "./ui/blur-fade";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { useState } from "react";
import React from "react";
import { EventMenu } from "../../payload-types";

export interface EventMenuProps {
  eventMenu: EventMenu;
}
export default function EventMenuContainer({ eventMenu }: EventMenuProps) {
  const [value, setValue] = useState<string | undefined>("0");
  return (
    <React.Fragment>
      <BlurFade inView>
        <h2 className="font-light">{eventMenu?.groupsMenu?.title}</h2>
        <p className="font-thin">{eventMenu?.groupsMenu?.subtitle}</p>
      </BlurFade>
      <Tabs
        defaultValue="meat"
        className="gap-0"
        value={value}
        onValueChange={setValue}
      >
        <BlurFade inView className="flex gap-4 items-center">
          <TabsList>
            {eventMenu?.groupsMenu?.options?.map((value, key) => (
              <TabsTrigger
                key={key}
                value={key.toString()}
                className="!font-thin !text-lg"
              >
                {value.title}
              </TabsTrigger>
            ))}
          </TabsList>
          {value === undefined && (
            <div className="w-[35px] animate-bounce-x">
              <Icons.toRightArrow />
            </div>
          )}
        </BlurFade>
        {eventMenu?.groupsMenu?.options?.map((menu, index) => (
          <TabsContent
            value={index.toString()}
            key={`groupsMenu-${index}`}
            className="grid grid-cols-1 lg:grid-cols-2 gap-2"
          >
            <div className="flex flex-col mt-4 gap-2">
              {menu?.prices?.map((value, priceIndex) => {
                return (
                  <BlurFade
                    key={`menu-price-${priceIndex}`}
                    inView
                    className="p-4 flex flex-col bg-tertiary text-tertiary-foreground rounded-xl"
                  >
                    <span className="font-light text-xl">{value.label}</span>
                    {value.description && (
                      <span className="font-thin">{value.description}</span>
                    )}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-2">
                      {value?.options?.map((price, priceIndex: number) => (
                        <div
                          className={cn(
                            "h-full p-4 flex flex-col justify-between gap-2 rounded-lg bg-white/10",
                          )}
                          key={`groupsMenu-${index}-price-${priceIndex}`}
                        >
                          <p className="font-thin text-sm">
                            {price.description}*
                          </p>
                          <p className="font-light text-2xl">
                            {priceFormatter.format(price.price)}
                          </p>
                        </div>
                      ))}
                    </div>
                    <p className="font-thin text-sm mt-1">
                      *Prezzo minimo:{" "}
                      {priceFormatter.format(
                        value.options!.reduce((accumulator, current) => {
                          if (accumulator == 0 || accumulator > current.price)
                            return current.price;
                          return accumulator;
                        }, 0),
                      )}
                    </p>
                    {value.optionals && (
                      <p className="font-thin text-sm">*{value.optionals}</p>
                    )}
                  </BlurFade>
                );
              })}
              <BlurFade
                inView
                className="bg-tertiary text-tertiary-foreground rounded-xl p-4"
              >
                {eventMenu?.groupsMenu?.notes?.map((note, noteIndex) => (
                  <p
                    key={`groupsMenu-${index}-note-${noteIndex}`}
                    className="font-thin text-sm"
                  >
                    {note.text}
                  </p>
                ))}
              </BlurFade>
            </div>

            <BlurFade
              inView
              className="bg-tertiary text-tertiary-foreground p-4 rounded-xl lg:mt-4"
            >
              <div className="flex flex-col gap-4">
                {menu.options?.map((option, optionIndex) => (
                  <div key={`groupsMenu-${index}-${optionIndex}`}>
                    <p className="font-light">{option.label}</p>
                    <ul className="list-disc list-inside ml-1">
                      {option.dishes?.map((dish, dishIndex) => (
                        <li
                          key={`groupsMenu-${index}-${optionIndex}-${dishIndex}`}
                          className="font-thin"
                        >
                          {dish.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </BlurFade>
          </TabsContent>
        ))}
      </Tabs>
    </React.Fragment>
  );
}
